require("../sass/main.scss");
import ReactDOM from "react-dom";
import React from "react";
import FeatureCards from "./components/FeatureCards";
import { MediaModal, PopupModal } from "./components/Modals";


const CustomContentPage = (): void => {
   //FeatureCards
   const featureCards = document.getElementById("customFeatureCards");
   //alert(featureCards);
   if(featureCards) {
    const contentSrc = featureCards.getAttribute("data-content");
    const itemClass = featureCards.getAttribute("data-itemClass");
    ReactDOM.render(
      <FeatureCards content={contentSrc ? window[contentSrc] : []} itemClassName={itemClass || null} />,
      featureCards
    );
  }

    //Popup Modal
const popupModal = document.createElement("div");
if (popupModal) {
  document.body.appendChild(popupModal);
  ReactDOM.render(<PopupModal />, popupModal);
}

  //Image Modal
  const mediaModal = document.createElement("div");
  if (mediaModal) {
    document.body.appendChild(mediaModal);
    ReactDOM.render(<MediaModal />, mediaModal);
  }
};
  
CustomContentPage();
